import { ViewModel,View } from "binder"
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class UserSearchViewModel extends SearchableSelectorBaseViewModel<user>{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    
    private shallSearch():boolean{
        return true;
    }
    protected async loadData(searchedText: string): Promise<user[]> {
        if(this.shallSearch()==false)
            return [];
        let result = await ServerConnection.callServer('/Complex/SecurityRawDataServices/SearchOrFindUser',{
            SearchText:searchedText,
            ResultCount:20,
        });
        return result.Users.map(x=>this.convert(x));
    }
    protected async loadById(id: string): Promise<user> {
        if(this.shallSearch()==false)
            return null;
        let result = await ServerConnection.callServer('/Complex/SecurityRawDataServices/SearchOrFindUser',{
            Id:id,
        });
        return this.convert(result.Users[0]);

    }
    private convert(dto:any):user{
        if(dto==null){
            return null;
        }else{
            let result = new user(this);
            result.id = dto.Id;
            result.username = dto.Username;
            result.personnelId = dto.PersonnelId;
            result.personnelCode = dto.PersonnelCode;
            result.personnelFullName = dto.PersonnelFullName;
            result.title = `${result.username} (${dto.PersonnelFullName})`;
            return result;
        }
    }    
}

export class user extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId;} private _personnelId: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode;} private _personnelCode: string;
    public set personnelFullName(v: string) { this._personnelFullName = v; } public get personnelFullName(): string { return this._personnelFullName;} private _personnelFullName: string;
}
